import { getInternalAppType } from 'integrations-lib/constants/AppIds';

export const isInternalApp = (appId?: number): boolean => {
  return !!appId && getInternalAppType(appId) !== undefined;
};

export const shouldHideAppStatuses = (appId?: number) => {
  return isInternalApp(appId) || !appId;
};
